import { render, staticRenderFns } from "./AddNewStage.vue?vue&type=template&id=d6644a74"
import script from "./AddNewStage.vue?vue&type=script&lang=js"
export * from "./AddNewStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6644a74')) {
      api.createRecord('d6644a74', component.options)
    } else {
      api.reload('d6644a74', component.options)
    }
    module.hot.accept("./AddNewStage.vue?vue&type=template&id=d6644a74", function () {
      api.rerender('d6644a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/AddNewStage.vue"
export default component.exports